"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = stringify;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

function stringify(obj) {
  var brackets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var sep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '&';
  var eql = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '=';
  var wrap = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  return Object.keys(obj).map(function (key) {
    if ((0, _typeof2["default"])(obj[key]) === 'object') {
      return stringify(obj[key], brackets, sep, eql, key);
    }

    var isArray = Object.prototype.toString.call(obj) === '[object Array]';
    var safeKey;

    if (isArray) {
      /* PHP expects query parameters of type array to have no key (ie. ...&duration[]=1&duration[]=2...)
      See http://php.net/manual/en/function.http-build-query.php for more details */
      if (brackets) {
        safeKey = wrap ? "".concat(encodeURIComponent(wrap), "[]") : encodeURIComponent(key);
      } else {
        safeKey = wrap ? "".concat(encodeURIComponent(wrap)) : encodeURIComponent(key);
      }
    } else {
      safeKey = wrap ? "".concat(encodeURIComponent(wrap), "[").concat(encodeURIComponent(key), "]") : encodeURIComponent(key);
    }

    return "".concat(safeKey).concat(eql).concat(encodeURIComponent(obj[key]));
  }).join(sep);
}